import { RouteRecordRaw } from 'vue-router'

import { LayoutApplicationSuspense } from '@/pages/suspense'

import { UserRoles } from '@/shared/types/router'

export const useApplicationLayout = (routeRecord: RouteRecordRaw): RouteRecordRaw => {
  if (!routeRecord.meta) {
    routeRecord.meta = {}
  }
  routeRecord.meta.layout = LayoutApplicationSuspense
  routeRecord.meta.roles = [UserRoles.SUBSCRIBER]
  return routeRecord
}
